import axios from 'axios'
import store from '@/store'
import { Notification } from 'element-ui'
import { getToken } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 120000
})

service.interceptors.request.use(config => {
  if (store.getters.token)
    config.headers['Authorization'] = getToken()
  return config
}, error => {
  Notification.error(error.response.data.message)
  Promise.reject(error)
})

service.interceptors.response.use(res => {
  if (res.data.code !== 200) {

    // Start handle Blob data
    if (res.data.type === 'application/json') {
      const reader = new FileReader()
      reader.readAsText(res.data);
      reader.onload = function () {
        Notification.error(JSON.parse(reader.result).message)
      }
      return;
    }
    // 下载 blob 档案（统一直接下载）
    if (res.data.type === 'application/force-download') {
      const blob = new Blob([res.data], {
        type: "application/vnd.ms-excel;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);
      const aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      if (res.headers['content-disposition']) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(res.headers['content-disposition']);
        aLink.download = matches[1];
      }
      document.body.appendChild(aLink);
      aLink.click();
      return;
    }
    // End handle Blob data

    Notification.error(res.data.message)

    if (res.data.code === 401) {
      waitForLocationReload('你已被登出，请重新登录')
      return
    }
    return Promise.reject(res.data.message)
  }

  /*
  PAY-1634
  特殊规则，代理、卡主显示代理层级时，只显示上级以及自己还有自己包含的下级
  */
  if (store.getters.userInfo && ['agent', 'customer'].indexOf(store.getters.userInfo.userType) !== -1 && res.data.data && res.data.data.list && Array.isArray(res.data.data.list)) {
    // 如果有 data list 的才跑回圈来取代代理层级
    res.data.data.list.forEach((obj) => {
      Object.keys(obj).forEach((key) => {
        // 代理层级 usernamePath 特别处理
        if (obj[key] && key === 'usernamePath') {
          let usernamePathArray = obj[key].split('/');
          let upperLevel = usernamePathArray[usernamePathArray.indexOf(store.getters.userInfo.username) - 1]; // 自己的上一级
          if (usernamePathArray[0] !== upperLevel) { // 上一级不是顶级的情况，usernamePath 就为顶级加上自己本身上级以下的所有用户
            obj[key] = obj[key][0] + '/' + obj[key].substring(obj[key].indexOf(upperLevel));
          }
        }
      });
    });
  }

  return res.data
}, error => {

  if (error.response.data && error.response.data.code === 401) {
    waitForLocationReload('登录超时，请重新登录')
    return
    // 排除红点泡泡接口在重启或无网路时出现「服务器忙碌中，请稍后再试」的通知
  } else if (error.response.data.path === '/Unallocated/all') {
    return
  } else if (error.response.data.status && error.response.data.status === 400) {
    Notification.error('参数有误，请确认查询条件')
    return
  } else {
    Notification.error('服务器忙碌中，请稍后再试')
    return Promise.reject(error)
  }

})

// 预防被登出时多个接口同时发 Notification
var countWaitReload = 0;
function waitForLocationReload(msg) {
  if (countWaitReload === 0) {
    Notification.error(msg)
    store.dispatch('LogOut').then(() => {
      setTimeout(() => {
        location.reload()
      }, 2000)
    })
  }
  countWaitReload++
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js